<script lang="ts">
  import { createEventDispatcher, onMount } from 'svelte';

  export let categoryList = [];
  export let initialSelectedIndex = -1;
  export let propertyNameToDisplay;

  let activeCategoryItem = null;
  const dispatch = createEventDispatcher();

  function onCategoryClick(categoryItem: any) {
    activeCategoryItem = categoryItem;
    dispatch('categorySelected', categoryItem);
  }

  onMount(() => {
    if (initialSelectedIndex > -1 && categoryList?.length >= initialSelectedIndex + 1) {
      onCategoryClick(categoryList[initialSelectedIndex]);
    }
  });
</script>

{#if categoryList?.length > 0}
  <swiper-container slides-per-view="auto" free-mode="true" space-between="16">
    {#each categoryList as categoryItem}
      <swiper-slide>
        <button
          class="btn-category"
          class:active={activeCategoryItem?.uid === categoryItem.uid}
          on:click={() => onCategoryClick(categoryItem)}
        >
          {categoryItem[propertyNameToDisplay] || 'No label'}
        </button>
      </swiper-slide>
    {/each}
  </swiper-container>
{/if}

<style lang="scss">
  @import '../../styles/colors.new.scss';

  button.btn-category {
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    padding: 12px;
    background-color: $secondary-gray-02;
    color: $neutral-dark-01;
    border: 0;
    border-radius: 100px;
    transition: all 250ms ease;

    &.active {
      background-color: $neutral-dark-01;
      color: $neutral-light-05;
    }
  }
</style>
